'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.AuthRemote = undefined;

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _helpers = require('./helpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AuthRemote = exports.AuthRemote = {
    postConfirmPassword: function postConfirmPassword(_ref) {
        var deployment = _ref.deployment,
            password = _ref.password,
            username = _ref.username;
        return new _promise2.default(function (resolve, reject) {
            var request = (0, _helpers.makePost)('<ITEM-API>auth/spalogin', deployment);
            request.send({ password: password, username: username });
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)(resolve, reject, err, response);
            });
        });
    },
    postForgotPassword: function postForgotPassword(_ref2) {
        var authToken = _ref2.authToken,
            deployment = _ref2.deployment,
            emailAddress = _ref2.emailAddress;
        return new _promise2.default(function (resolve, reject) {
            var request = (0, _helpers.makePost)('<MAINHOST-API>api/pw_reset', deployment);
            (0, _helpers.addAuthToken)(request, authToken);

            var _emailAddress$split = emailAddress.split('@'),
                _emailAddress$split2 = (0, _slicedToArray3.default)(_emailAddress$split, 2),
                username = _emailAddress$split2[0],
                domain = _emailAddress$split2[1];

            request.query({ client_version: '4.3' });
            request.type('form');
            request.send({ email: username.replace('+', '%2B') + '@' + domain }); // To allow emails with pluses
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)(resolve, reject, err, response);
            });
        });
    },
    postUpdatePassword: function postUpdatePassword(_ref3) {
        var authToken = _ref3.authToken,
            deployment = _ref3.deployment,
            newPassword = _ref3.newPassword,
            oldPassword = _ref3.oldPassword;
        return new _promise2.default(function (resolve, reject) {
            var request = (0, _helpers.makePost)('<ITEM-API>auth/update-password', deployment);
            (0, _helpers.addAuthToken)(request, authToken);
            request.send({ newPassword: newPassword, oldPassword: oldPassword });
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)(resolve, reject, err, response);
            });
        });
    }
};


//////////////////
// WEBPACK FOOTER
// ./src/redux/api/remote/auth.js
// module id = i2pf
// module chunks = 46